<template>
  <div>
    <div class="loader-content" :class="[{ 'alignSpinnerTop': alignSpinnerTop }, loaderContentClass]">

      <div class="mb-5 animated bounceInDown" v-if="welcomeMessage && this.$store.state.deviseLoading == 'complete' && this.$store.state.user.profile">
        <h1 class="m-0 text-blue-ml">
          <small>Olá<span v-if="firstName">,</span></small>
          <br v-if="firstName">
          {{ firstName }}!
        </h1>
      </div>

      <SpinnerLoader  />

    </div>
  </div>
</template>

<script>
import SpinnerLoader from '../Loader/SpinnerLoader.vue';

export default {
  name: 'LoaderContent',

  computed: {
    firstName() {
      if (this.$store.state.user.profile.name) {
        return this.$store.state.user.profile.name.split(' ')[0];
      }
      return null;
    },
  },

  props: {
    welcomeMessage: {
      default: true,
    },
    alignSpinnerTop: {
      default: false,
    },
    loaderContentClass: {
      default: '',
    },
  },

  components: {
    SpinnerLoader,
  },
};
</script>

<style lang="scss" scoped>
  .loader-content{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: rgba(255, 255, 255, .95);
    z-index: 1;
    padding: 10%;

    &.alignSpinnerTop{
      justify-content: flex-start;
    }
  }
</style>
